import BaseView from "./baseView.js";
import { formatMenuLabel } from "../helper.js";

const generateSubsectionsHTML = (subsections) => {
  const linksHTML = subsections.map((subsection) => {
    const linkHTML = `<li><a href="javascript:void(0)" class="menu-level-2 leftmenu-link" data-id="${subsection.dataId}">${subsection.label}</a></li>`;
    return linkHTML;
  });
  return linksHTML.join("");
};

const generateTopicsHTML = (topics) => {
  const topicsHTML = topics.map((topic) => {
    const topicLinkHTML = `<li><a href="javascript:void(0)" class="menu-level-1 leftmenu-link" data-id="${topic.dataId}">${topic.label}</a></li>`;
    const subsectionsHTML = generateSubsectionsHTML(topic.children);
    const topicHTML = topicLinkHTML + subsectionsHTML;
    return topicHTML;
  });
  return topicsHTML.join("");
};

class LeftMenuView extends BaseView {
  constructor() {
    super("#left-menu", "leftmenu-link");
  }

  generateLeftMenuHTML = (section) => {
    const sectionLabel = formatMenuLabel(section.name);
    const rootHTML = `<li class="menu-level-0" data-id="${section.name}">${sectionLabel}</li>`;
    const topicsHTML = generateTopicsHTML(section.children);
    const leftMenuHTML = `<ul id="left-menu-list">${rootHTML}${topicsHTML}</ul>`;
    return leftMenuHTML;
  };

  toggleLeftMenu = (isVisible) => {
    const leftMenu = document.getElementById("left-menu");
    leftMenu.classList.toggle("active", isVisible);
  };

  scrollToLink = (dataId) => {
    const targetLink = document.querySelector(
      `#left-menu a.leftmenu-link[data-id="${dataId}"]`
    );
    if (targetLink) {
      targetLink.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  };
}

export default new LeftMenuView();
